export const selectorFunctions = {
  getData: state => state?.data,
  getLoaded: state => state?.loaded,
  getLoading: state => state?.loading,
  getError: state => state?.error,
  getTimestamp: state => state?.timestamp
};
